// src/components/PasswordInput.jsx
//
// Поле пароля/PIN с «глазиком» справа — показать/скрыть набранное.
// API как у обычного <input>: все props пробрасываются, type подменяется.

import { useState } from 'react';
import Icon from './Icon';

export default function PasswordInput({ className = 'input', style, ...props }) {
  const [shown, setShown] = useState(false);
  return (
    <div style={{ position: 'relative' }}>
      <input
        {...props}
        className={className}
        type={shown ? 'text' : 'password'}
        style={{ ...style, paddingRight: 48 }}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShown(s => !s)}
        onMouseDown={e => e.preventDefault()} /* не уводить фокус из поля */
        aria-label={shown ? 'Скрыть' : 'Показать'}
        style={{
          position: 'absolute', top: 0, right: 0, bottom: 0, width: 46,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'none', border: 'none', cursor: 'pointer',
          color: shown ? 'var(--brand-primary)' : 'var(--fg-muted)',
        }}
      >
        <Icon name={shown ? 'eyeOff' : 'eye'} size={20} />
      </button>
    </div>
  );
}
